module.exports = "/images/undelivered.svg";